import { ChartDepths, ChartLayersBase } from './mg-layers';
import { LayersFactory } from '@meteogroup/map-layers';
import ImageWMSSource from 'ol/source/ImageWMS';
import Layer from 'ol/layer/Layer';
import ImageLayer from 'ol/layer/Image';
import { StyleName } from '../../local_modules/voyage-style/src/voyage-style';
import { Source } from 'ol/source';
import ImageSource from 'ol/source/Image';

// EPSG:4326 - Unprojected
// EPSG:3395 - World Mercator
// EPSG:3857 - Pseudo/Web Mercator

const _PROJECTION = (<any>window)["appenv"].projection;


enum ColorScheme
{
    Day = 1,
    Dusk = 2,
    Night = 3
}

export class MgChartLayersImpl extends ChartLayersBase
{
    constructor(layersFactory: LayersFactory) {
        super();
        this._layersFactory = layersFactory;
    }
    get layers() {
        return this._layers;
    }
    setChartDepths(depths: ChartDepths) {
        this._depths = depths;
        this._setChartParams({
            CSVALUE: this._getChartsCSVALUE()
        });
    }

    setColorScheme(colorScheme: StyleName) {
        switch (colorScheme)
        {
            case StyleName.default:
                this._colorScheme = ColorScheme.Day;
                break;

            case StyleName.dusk:
                this._colorScheme = ColorScheme.Dusk;
                break;

            case StyleName.night:
                this._colorScheme = ColorScheme.Night;
                break;
        }

        this._setChartParams({
            CSVALUE: this._getChartsCSVALUE()
        });
    }

    async initialize() {
        // Auxiliary NENC layer (backdrop for when ENC is slow to render)
        this._backgroundWMSLayer = this._layersFactory!.createChartWMSLayer({
            params: {
                LAYERS: 'NENC',
                CSVALUE: this._getChartsCSVALUE(),
                OBJECTGROUP: null,
                OBJECTFILTERNEGATION: false,
            },
        });

        this._layers.push(this._backgroundWMSLayer);

        // ON:
        //   lights (1)
        //   text (2)
        //   shallow soundings (8)
        //   deep soundings (9)
        //   national text (16)

        this._chartsWMSLayer = this._layersFactory!.createCartImageWMSLayer({
            title: 'ChartWMS',
            visible: true,
            params: {
                LAYERS: 'ENC',
                CSBOOL: '4183',
                CSVALUE: this._getChartsCSVALUE(),
                OBJECTGROUP: null,
                OBJECTFILTERNEGATION: false,
            },
            ratio: 1,
            projection: _PROJECTION,
        });

        this._layers.push(this._chartsWMSLayer!);

        this._initialized = true;
    }

    zoomLevelChanged(zoom: number) {
        const source = <ImageWMSSource>(this._chartsWMSLayer!.getSource());
        if (zoom <= 6) {
            source.updateParams({
                LAYERS: 'NENC',
            });
        } else {
            source.updateParams({
                LAYERS: 'ENC',
            });
        }
    }


    private _initialized: boolean = false;
    private _layers: Layer<Source>[] = [];
    private _layersFactory: LayersFactory|null = null;
    private _colorScheme: ColorScheme = ColorScheme.Day;
    private _depths: ChartDepths = {
        safetyContour: 20,
        shallowContour: 15,
        deepContour: 30,
        safetyDepth: 20
    };
    private _chartsWMSLayer: ImageLayer<ImageSource>|null = null;
    private _backgroundWMSLayer: any|null = null; // If we use 'createChartWMSLayer' to get the aux layer correct, the type is TileLayer (maybe wrong interface)

    private _setChartParams(params: {[index:string]: any}) {
        let src =  <ImageWMSSource>(this._chartsWMSLayer!.getSource());
        src.updateParams(params);
        src.refresh();
        src = this._backgroundWMSLayer!.getSource();
        src.updateParams(params);
        src.refresh();
    }

    private _getChartsCSVALUE(): string
    {
        return `${this._depths.safetyContour},${this._depths.shallowContour},${this._depths.deepContour},${this._depths.safetyDepth},1,2,${this._colorScheme},10000000,500000,500000,0`;
    }

}
